import styled from "styled-components";

export const ScrollTopBtn = styled.div`
  width: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: fixed;
  bottom: 20px;
  right: 23px;
  z-index: 999;
  cursor: pointer;
  @media (max-width: 991px) {
    right: 13px;
    bottom: 135px;
    width: 44px;
    height: 44px;
  }
`;

/* 상하 테두리 제거 */
export const FooterBodySection = styled.section`
  width: 100%;
  position: relative;
  border:1px solid #ececec;
  @media (max-width: 1199px) {
    display: none;
  }
`;

export const FooterBottomWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  margin-bottom: 50px;

  @media (max-width: 1199px) {
    flex-wrap: wrap;
  }
  @media (max-width: 767px) {
    flex-wrap: wrap;
  }
`;

export const FooterBottomCol = styled.div`
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  & p {
    margin: 0;
  }

  & li {
    width: fit-content;
    display: flex;
    align-items: center;
  }

  & h6 {
    margin-right: 5px;
  }

  & span {
    word-break: keep-all;
    margin-right: 5px;
  }

  & a {
    width: 250px;
  }

  @media (max-width: 1199px) {
    width: 100%;
  }
`;

/* contact-info: 테두리/호버 그림자 제거, 미니멀 스타일 */
export const ContactInfo = styled.ul`
  --ci-label: #2a3b47;
  --ci-text: #415a6b;
  --ci-accent: #2563eb;
  --ci-muted: #a3b4bf;

  display: grid;
  grid-template-columns: 1fr;
  gap: 6px;
  padding: 0; /* 카드 느낌 제거 */
  background: transparent; /* 배경/보더 제거 */

  .contact-info__item {
    display: grid;
    grid-template-columns: 24px auto 1fr; /* 아이콘 / 라벨 / 값 */
    align-items: center;
    gap: 10px 12px;
    padding: 4px 0; /* 라인 간격만 유지 */
    background: transparent; /* 보더/배경 제거 */
  }

  .contact-info__icon {
    width: 20px;
    height: 20px;
    object-fit: contain;
    opacity: .9;
  }

  .contact-info__label {
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    color: var(--ci-label);
    white-space: nowrap;
    line-height: 1.2;
  }

  .contact-info__value {
    color: var(--ci-text);
    font-size: 15px;
    line-height: 1.6;
  }

  .contact-info__value a {
    color: var(--ci-accent);
    text-decoration: none;
  }
  .contact-info__value a:hover {
    text-decoration: underline;
  }

  .contact-info__divider {
    margin: 0 8px;
    color: var(--ci-muted);
  }

  .contact-info__cta {
    padding: 6px 10px;
    border: 1px solid var(--ci-accent);
    border-radius: 10px;
    font-weight: 600;
  }

  @media (max-width: 480px) {
    .contact-info__item {
      grid-template-columns: 20px auto 1fr;
      padding: 2px 0;
    }
    .contact-info__label,
    .contact-info__value {
      font-size: 13px;
    }
  }
`;

export const MobileSocialIconWrapper = styled.div`
  display: flex;
  align-items: center;
  align-self: center;

  & h6 {
    display: inline-block;
    margin-right: 15px;
  }
  & a {
    text-align: center;
    font-size: 14px;
    margin-right: 5px;
    transition-duration: 0.5s;
    height: 40px;
    width: 40px !important;
    display: inline-flex;
    background: #3bb77e;
    border-radius: 30px;
    line-height: 1;
    align-content: center;
    justify-content: center;
    align-items: center;
    :hover {
      opacity: 0.6;
      transform: translateY(-2px);
      transition-duration: 0.5s;
      margin-top: -2px;
    }
  }
  & img {
    max-width: 20px;
    max-height: 20px;
  }
`;

export const FooterCopyWrapper = styled.div`
  width: 100%;
  padding-right: var(--bs-gutter-x, 0.75rem);
  padding-left: var(--bs-gutter-x, 0.75rem);
`;

export const FooterContainer = styled.footer`
  width: 100%;
`;

/* 모바일 섹션 테두리 제거 */
export const MobileFooterBodySection = styled.section`
  display: none;
  width: 100%;
  position: relative;

  @media (max-width: 1199px) {
    display: flex;
  }
`;

export const MobileListWrapper = styled.ul`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  margin-bottom: 20px;
  & li {
    display: flex;
    justify-content: center;
    align-items: center;
    & a {
      color: #696969;
      font-size: 14px;
    }
  }
  @media (max-width: 354px) {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 5px;
    grid-row-gap: 5px;
    & li {
      & a {
        font-size: 14px;
      }
    }
  }
`;

export const MobileContactInfo = styled.ul`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  
  & li {
    display: flex;
    align-items: center;
    & h6 {
      color: #696969;
      margin-right: 10px;
      font-size: 16px;
      white-space: nowrap;
    }
    & span {
      color: #696969;
      font-size: 16px;
      word-break: keep-all;
    }
  }
  @media (max-width: 575px) {
    & li {
      & h6 {
        font-size: 14px;
      }
      & span {
        color: #696969;
        font-size: 14px;
        word-break: keep-all;
      }
    }
  }
`;
